import { v4 as uuid } from 'uuid';
import { BillingRate, BillingRateTypes } from '../billing/BillingRate';

export const PayPeriodTypes = {
    Weekly: 1,
    Biweekly: 2,
};

export class Organization {
    id = null;

    name = '';

    locationId = null;

    parentCompanyId = null;

    tenantCompanyId = null;

    customerCompanyId = null;

    address1 = '';

    address2 = '';

    city = '';

    country = '';

    state = '';

    countryId = null;

    stateId = null;

    zip = '';

    phone = '';

    countryCode = '';

    types = [];

    typesFlat = '';

    contacts = [];

    companyChargeTypeGroups = [];


    operationsCentersApply = false;

    subcontractorsApply = false;

    parentCustomerApply = false;

    hasAlternativePayroll = false;

    useInvoicing = false;

    operationsCenterUseInvoicing = false;

    showRateForm = false;

    selectedRate = null;

    billingRates = [];

    defaultDispatchPortId = null;

    groupBillingRates = [];

    companyMinimumWageRates = [];

    useAsBillingAddress = true;

    billingOTDays = 1;

    payPeriodTypeId = 1;

    payPeriodOvertimeThreshold = 40;

    minimumBillUnits = 0.00;

    includeRequestorNameOnInvoice = false;

    includeDueDateOnInvoice = false;

    includeStartEndTimeOnInvoice = false;

    isNationalAccount = false;

    billFirstPartialPeriod = true;

    businessNumber = '';

    cancellationBillQty = 0.00;
    isCancelledJobBillingDisabled = false;
    cancellationsAlwaysStraightTime = false;
}

export class OrganizationContact {
    // 2022-05-23 - M. Nicol - changed to null from uuid().
    // OrganizationContactForm.js assumes we're editing an existing contact if id has a vaule.
    // OrganizationForm.js uses array.util.upsert though to assume that identical keys are for the
    // same vaule.  I updated it with a new optional parameter to consider nulls equal or not.
    id = 0; // uuid();

    firstName = '';

    lastName = '';

    title = '';

    email = '';

    mobilePhone = '';

    mobilePhoneIsPrimary = false;

    officePhone = '';

    officePhoneIsPrimary = false;

    locationContactTypeId = null;

    locationContactTypeName = '';

    isActive = true;
}

export class CompanyChargeTypeBillingRate {
    companyId = null;

    chargeTypeId = null;

    chargeTypeName = '';

    billingRateId = uuid();

    billingRate = new BillingRate();

    rateType = BillingRateTypes.CHARGE_TYPE;
}

export class CompanyChargeTypeGroupBillingRate {
    companyId = null;

    chargeTypeGroupId = null;

    chargeTypeName = '';

    billingRateId = uuid();

    billingRate = new BillingRate();

    rateType = BillingRateTypes.CHARGE_TYPE_GROUP;
}

export class MinimumWageRate {
    id = 0;

    companyId = 0;

    payRate = null;

    startDate = null;

    endDate = null;
}

export const OrganizationTypes = {
    Billing: 2,
    Payroll: 3,
    Dispatch: 4,
    Customer: 5,
    OperationsCenter: 6,
    CustomerSubcontractor: 7,
    Carrier: 8,
    ParentCustomer: 9,
    Prospect: 10,
    VendorBillOffice: 11,
    DispatchPort: 12,
};

export const BillingOTDays = {
    Sunday: 1,
    Monday: 2,
    Tuesday: 4,
    Wednesday: 8,
    Thursday: 16,
    Friday: 32,
    Saturday: 64,
};